// Segment analytics methods

const segmentTrack = (eventName, eventProperties = {}) => {
  const name = getSegmentEventName(eventName)
  const { enableAnonymousSegmentTracking } = pipelineConfig?.frontendCustomFields || {}
  const isAnonymousTrackingEnabled = enableAnonymousSegmentTracking?.value?.toLowerCase() === "true"
  const store = window.Alpine.store("data")
  const storeData = (store && store.values) || {}
  const { isEmailStepCompleted } = storeData

  if (!window.analytics) {
    console.warn(`Segment is not available on the page.`)
    return
  }

  if (isAnonymousTrackingEnabled || (!isAnonymousTrackingEnabled && isEmailStepCompleted)) {
    window.analytics.track(name, eventProperties)
  }
}

const segmentIdentifyUser = async (segmentUserId, email) => {
  if (!window.analytics) {
    console.warn(`Segment is not available on the page. Attempted: identify`, segmentUserId)
    return
  }

  if (!segmentUserId) {
    return
  }

  let segmentUserIdLocal = window.localStorage.getItem("ajs_user_id")

  // Sanitize if necessary
  if (
    segmentUserIdLocal &&
    segmentUserIdLocal.startsWith('"') &&
    segmentUserIdLocal.endsWith('"')
  ) {
    segmentUserIdLocal = JSON.parse(segmentUserIdLocal)
  }

  if (segmentUserIdLocal !== segmentUserId) {
    window.localStorage.setItem("ajs_user_id", segmentUserId)
    await window.analytics.identify(segmentUserId, { email })
  }
}

const getSegmentEventName = (key) => {
  return pipelineConfig.segmentEventKeys[key] ?? key
}

export { segmentTrack, getSegmentEventName, segmentIdentifyUser }
